import api from './api';

// 获取操作日志
export const getLogs = async (params = {}) => {
  try {
    const response = await api.get('/logs', { params });
    
    // 检查响应中是否直接包含logs和pagination字段
    if (response.data.logs && response.data.pagination) {
      return {
        items: response.data.logs,
        total: response.data.pagination.total,
        page: response.data.pagination.page,
        pageSize: response.data.pagination.pageSize,
        totalPages: response.data.pagination.totalPages
      };
    } else if (response.data.success) {
      // 兼容旧的响应格式
      return response.data.logs;
    } else {
      throw new Error(response.data.message || '获取日志失败');
    }
  } catch (error) {
    if (error.response && error.response.data) {
      throw new Error(error.response.data.message || '获取日志失败');
    }
    throw error;
  }
};

// 搜索日志
export const searchLogs = async (params) => {
  try {
    const response = await api.get('/logs/search', { params });
    
    // 检查响应中是否直接包含logs和pagination字段
    if (response.data.logs && response.data.pagination) {
      return {
        items: response.data.logs,
        total: response.data.pagination.total,
        page: response.data.pagination.page,
        pageSize: response.data.pagination.pageSize,
        totalPages: response.data.pagination.totalPages
      };
    } else if (response.data.success) {
      // 兼容旧的响应格式
      return response.data.logs;
    } else {
      throw new Error(response.data.message || '搜索日志失败');
    }
  } catch (error) {
    if (error.response && error.response.data) {
      throw new Error(error.response.data.message || '搜索日志失败');
    }
    throw error;
  }
};

// 获取日志统计数据
export const getLogStats = async () => {
  try {
    const response = await api.get('/logs/stats');
    
    // 检查响应中是否直接包含统计数据字段
    if (response.data.totalLogs !== undefined) {
      // 新格式直接返回统计数据
      return {
        totalLogs: response.data.totalLogs || 0,
        todayLogs: response.data.todayLogs || 0,
        userCount: response.data.userCount || 0,
        actionTypes: response.data.actionTypes || []
      };
    } else if (response.data.success) {
      // 兼容旧格式
      return response.data.stats || {
        totalLogs: 0,
        todayLogs: 0,
        userCount: 0,
        actionTypes: []
      };
    } else {
      throw new Error(response.data.message || '获取日志统计失败');
    }
  } catch (error) {
    if (error.response && error.response.data) {
      throw new Error(error.response.data.message || '获取日志统计失败');
    }
    throw error;
  }
};
